import React from "react";
import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import "./UploadInput.scss";

const UploadInput = ({
  label = "Upload Files", // Default label
  fileList = [], // Controlled file list
  onChange, // Handler for file changes
  disabled = false, // Disabled state
  className = "", // Additional class for customization
  style = {}, // Additional inline styles
}) => {
  return (
    <div className={`file-upload-input-wrapper ${className}`}>
      {/* {label && <label className="file-upload-label">{label}</label>} */}
      <Upload
        fileList={fileList}
        onChange={onChange}
        beforeUpload={() => false} // Prevent auto-upload (handle manually if needed)
        disabled={disabled}
        style={style}
      >
        <Button
          icon={<UploadOutlined />}
          disabled={disabled}
          className="file-upload-button"
        >
          Upload
        </Button>
      </Upload>
    </div>
  );
};

export default UploadInput;
